import * as React from "react";
import {DragEventHandler} from "react";
import {EventManager} from "shared/utilities/Events/EventManager";

import {ControlTypeEnum} from "PageBuilder/pagebuilder/Controls/NormalPDFControlFactory";
import {Dialog} from "shared/controls/Dialogs/core/Dialog";

import {FieldDragStarted} from "InternalShared/Events/FieldDragStarted";
import {FieldDragEnded} from "InternalShared/Events/FieldDragEnded";
import {LicenseIsRequired} from "InternalShared/Dialog/LicenseIsRequired";



export abstract class FieldItemBase<p extends FieldItemBaseProps,s extends FieldItemBaseState> extends React.Component<p, s> {
    static defaultProps: Partial<FieldItemBaseProps> = {};
    IsPR:boolean=false;
    constructor(props: FieldItemBaseProps) {
        super(props as any);
        this.state = {} as any;
    }

    protected abstract GetImage();
    protected abstract GetText();
    protected abstract GetType():string;

    public render() {
        return (
            <div  className={'fieldItem'} draggable={true} onDragStart={(e)=>this.OnDrag(e as any)} onDragEnd={e=>this.OnDrop(e as any)}>
                <img  style={{border:'1px solid #dfdfdf',marginRight:5}} alt={'text'} src={rednaoVar.URL+'images/toolIcons/'+this.GetImage()}/>
                <span>{this.GetText()}</span>
            </div>
        )
    }

    private OnDrag(e:DragEvent) {
        if(rednaoVar.IsPr==""&&this.IsPR) {
            Dialog.Show(<LicenseIsRequired Message={'This field is only available in the full version'}/>);
            e.preventDefault();
            return;
        }
        let img=document.createElement('img');
        img.src=rednaoVar.URL+'images/toolIcons/'+this.GetImage();
        if(typeof e.dataTransfer.setDragImage!='undefined')
            e.dataTransfer.setDragImage(img,25,25);
        e.dataTransfer.setData('Text',this.GetType());
        EventManager.Publish(new FieldDragStarted());


    }

    protected OnDrop(e: DragEvent) {
        EventManager.Publish(new FieldDragEnded());
    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
export interface FieldItemBaseProps {

}

export interface FieldItemBaseState {

}

//#endregion "My Region"